import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BlogCTA() {
  const { t } = useTranslation();
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-6 pb-10 lg:pb-[100px]">
      <div className="flex flex-col items-start justify-between gap-6 rounded-[20px] bg-secondary-200 px-6 py-9 sm:flex-row sm:items-center lg:px-13 lg:py-12">
        <div className="max-w-[52ch]">
          <h3 className="text-[22px] font-extrabold tracking-[-0.03em] text-secondary-900 lg:text-[26px]">
            {t('blog.ctaTitle')}
          </h3>
          <p className="mt-2 text-[14px] leading-[1.6] text-secondary-600 lg:text-[15px]">
            {t('blog.ctaText')}
          </p>
        </div>
        <Link
          to="/contact"
          className="inline-flex shrink-0 items-center gap-2 rounded-full bg-primary-500 px-6 py-3.5 text-[14px] font-bold text-white transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          {t('blog.contactExpert')}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>
    </section>
  );
}